import React from 'react';
import { Hero } from './components/Hero';
import { Testimonios } from './components/Testimonios';
import { Problema } from './components/Problema';
import { Agitacion } from './components/Agitacion';
import { QueEsSistema } from './components/QueEsSistema';
import { Comparativa } from './components/Comparativa';
import { Bonos } from './components/Bonos';
import { Urgencia } from './components/Urgencia';
import { Pricing } from './components/Pricing';
import { CostoNoActuar } from './components/CostoNoActuar';
import { Garantia } from './components/Garantia';
import { Faq } from './components/Faq';
import { CtaFinal } from './components/CtaFinal';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
export function App() {
  return <div className="w-full min-h-screen bg-navy text-white font-sans pb-[80px] md:pb-0" data-id="element-0">
      <Hero data-id="element-1" />
      <Testimonios data-id="element-2" />
      <Problema data-id="element-3" />
      <Agitacion data-id="element-4" />
      <QueEsSistema data-id="element-5" />
      <Comparativa data-id="element-6" />
      <Bonos data-id="element-7" />
      <Urgencia data-id="element-8" />
      <Pricing data-id="element-9" />
      <CostoNoActuar data-id="element-10" />
      <Garantia data-id="element-11" />
      <Faq data-id="element-12" />
      <CtaFinal data-id="element-13" />
      <Footer data-id="element-14" />
      <StickyCta data-id="element-15" />
    </div>;
}